<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Edit APHT</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/apht/created">
            <CIcon name="cil-file" />
            APHT
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CRow class="mb-5">
        <CCol class="col-12 p-1">
          <CCard class="custom-form-card ml-2 mr-2">
            <CCardBody>
              <CRow>
                <CCol class="col-12 col-lg-6">
                  <b-form-group
                    :invalid-feedback="formData.applNo.feedback"
                    valid-feedback="No. Appl is available."
                    label="No. Appl"
                    label-for="form-appl-no"
                    :state="formData.applNo.isValid"
                  >
                    <b-input-group>
                      <b-form-input
                        v-model="formData.applNo.value"
                        :state="formData.applNo.isValid"
                        placeholder="No. Appl"
                        id="form-appl-no"
                        @input="clearFormAppl"
                        maxlength="12"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          variant="primary"
                          :disabled="formData.applNo.isValid"
                          :title="formData.applNo.isValid ? 'ID already valid' : ''"
                          @click="validateApplNo"
                          style="width:4.5rem"
                        >
                          <b-spinner small v-if="formData.applNo.isChecking" />
                          <span v-else>Check</span>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <!-- <b-form-group
                    invalid-feedback="This input is required."
                    label="No. Sertifikat Tanah"
                    label-for="form-certificate-no"
                    :state="formData.certificateNo.isValid"
                  >
                    <b-input-group>
                      <b-form-input
                        v-model="formData.certificateNo.value"
                        :state="formData.certificateNo.isValid"
                        placeholder="No. Sertifikat Tanah"
                        id="form-certificate-no"
                        maxlength="50"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Status Sertifikat"
                    label-for="form-certificate-status"
                    :state="formData.certificateStatus.isValid"
                  >
                    <b-input-group>
                      <b-form-input
                        v-model="formData.certificateStatus.value"
                        :state="formData.certificateStatus.isValid"
                        placeholder="Status Sertifikat"
                        id="form-certificate-status"
                        maxlength="50"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Harga Objek"
                    label-for="form-object-price"
                    :state="formData.objectPrice.isValid"
                  >
                    <b-form-input
                      :value="$helper.thousandSeparator(formData.objectPrice.value)"
                      maxlength="19"
                      @input="formData.objectPrice.value = $event.toString().replace(/\./g, '')"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                      :state="formData.objectPrice.isValid"
                      placeholder="Harga Objek"
                      type="text"
                      id="form-object-price"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Fee Notaris"
                    label-for="form-notary-fee"
                    :state="formData.notaryFee.isValid"
                  >
                    <b-form-input
                      :value="$helper.thousandSeparator(formData.notaryFee.value)"
                      maxlength="19"
                      @input="formData.notaryFee.value = $event.toString().replace(/\./g, '')"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                      :state="formData.notaryFee.isValid"
                      placeholder="Fee Notaris"
                      type="text"
                      id="form-notary-fee"
                    ></b-form-input>
                  </b-form-group> -->
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Office"
                    label-for="form-office-code"
                    :state="formData.officeCode.isValid"
                  >
                    <multiselect 
                      v-model="formData.officeCode.value" 
                      :options="formData.officeCode.options" 
                      :state="formData.officeCode.isValid"
                      :class="{custom_multiselect_invalid: formData.officeCode.isValid === false}"
                      id="form-office-code"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!formData.officeCode.isLoaded"
                      openDirection="bottom"
                      label="nameFull"
                      track-by="officeCode"
                      :internalSearch="false"
                      :preserveSearch="true"
                      @search-change="populateOffice"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="formData.officeCode.currentPage < formData.officeCode.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendOffice" v-if="formData.officeCode.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Notes"
                    label-for="form-notes"
                    :state="formData.notes.isValid"
                  >
                    <b-form-textarea
                      v-model="formData.notes.value"
                      :state="formData.notes.isValid"
                      maxlength="300"
                      placeholder="Notes"
                      id="form-notes"
                      style="height: 6.8rem;"
                    ></b-form-textarea>
                  </b-form-group>
                </CCol>
                <CCol class="col-12 col-lg-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="No. Kontrak"
                    label-for="form-contract-no"
                    :state="formData.contractNo.isValid"
                  >
                    <b-form-input
                      v-model="formData.contractNo.value"
                      :state="formData.contractNo.isValid"
                      placeholder="No. Kontrak"
                      disabled
                      id="form-contract-no"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Nama Customer"
                    label-for="form-customer-name"
                    :state="formData.customerName.isValid"
                  >
                    <b-form-input
                      v-model="formData.customerName.value"
                      :state="formData.customerName.isValid"
                      placeholder="Nama Customer"
                      disabled
                      id="form-customer-name"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Nilai Penjaminan"
                    label-for="form-guarantee-value"
                    :state="formData.guaranteeValue.isValid"
                  >
                    <b-form-input
                      :state="formData.guaranteeValue.isValid"
                      :value="$helper.thousandSeparator(formData.guaranteeValue.value)"
                      placeholder="Nilai Penjaminan"
                      disabled
                      id="form-guarantee-value"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Pokok Pembiayaan"
                    label-for="form-financing-principal"
                    :state="formData.financingPrincipal.isValid"
                  >
                    <b-form-input
                      :value="$helper.thousandSeparator(formData.financingPrincipal.value)"
                      :state="formData.financingPrincipal.isValid"
                      placeholder="Pokok Pembiayaan"
                      disabled
                      id="form-financing-principal"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <b-table striped hover show-empty
                    responsive="xl"
                    :items="table.items"
                    :fields="table.fields"
                    :busy="!table.isLoaded"
                    no-local-sorting no-sort-reset
                  >
                    <template slot="empty">
                      <div v-if="!table.isLoaded" class="text-center">
                        <b-spinner label="Fetching Data..."></b-spinner>
                      </div> 
                      <div v-else class="text-center">
                        Tidak ada data
                      </div> 
                    </template>
                    <template #cell(nomorSertifikatTanah)="row">
                      <b-form-group
                        class="mb-0"
                        :invalid-feedback="table.validationItems[row.index].nomorSertifikatTanah.feedback"
                      >
                        <b-form-input
                          v-model="row.item.nomorSertifikatTanah"
                          :state="table.validationItems[row.index].nomorSertifikatTanah.isValid"
                          maxlength="50"
                          type="text"
                          placeholder="Nomor Sertifikat"
                          autocomplete="off"
                          style="max-width: 200px;"
                        ></b-form-input>
                      </b-form-group>
                    </template>
                    <template #cell(namaSertifikatTanah)="row">
                      <b-form-group
                        class="mb-0"
                        :invalid-feedback="table.validationItems[row.index].namaSertifikatTanah.feedback"
                      >
                        <b-form-input
                          v-model="row.item.namaSertifikatTanah"
                          :state="table.validationItems[row.index].namaSertifikatTanah.isValid"
                          maxlength="50"
                          type="text"
                          placeholder="Nama Sertifikat"
                          autocomplete="off"
                          style="max-width: 200px;"
                        ></b-form-input>
                      </b-form-group>
                    </template>
                    <template #cell(statusHak)="row">
                      <b-form-group
                        class="mb-0"
                        :invalid-feedback="table.validationItems[row.index].statusHak.feedback"
                      >
                        <b-form-input
                          v-model="row.item.statusHak"
                          :state="table.validationItems[row.index].statusHak.isValid"
                          maxlength="50"
                          type="text"
                          placeholder="Status Hak"
                          autocomplete="off"
                          style="max-width: 200px;"
                        ></b-form-input>
                      </b-form-group>
                    </template>
                    <template #cell(nilaiAppraisal)="row">
                      <b-form-group
                        class="mb-0"
                        :invalid-feedback="table.validationItems[row.index].nilaiAppraisal.feedback"
                      >
                        <b-form-input
                          :value="$helper.thousandSeparator(row.item.nilaiAppraisal)"
                          :state="table.validationItems[row.index].nilaiAppraisal.isValid"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          @input="row.item.nilaiAppraisal = $event.toString().replace(/\./g, '')"
                          maxlength="19"
                          type="text"
                          placeholder="Nilai Appraisal"
                          autocomplete="off"
                          style="max-width: 200px;"
                        ></b-form-input>
                      </b-form-group>
                    </template>
                    <template #cell(notaryFee)="row">
                      <b-form-group
                        class="mb-0"
                        :invalid-feedback="table.validationItems[row.index].notaryFee.feedback"
                      >
                        <b-form-input
                          :value="$helper.thousandSeparator(row.item.notaryFee)"
                          :state="table.validationItems[row.index].notaryFee.isValid"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          @input="row.item.notaryFee = $event.toString().replace(/\./g, '')"
                          maxlength="19"
                          type="text"
                          placeholder="Min Pokok Pembiayaan"
                          autocomplete="off"
                          style="max-width: 200px;"
                        ></b-form-input>
                      </b-form-group>
                    </template>
                    <template #cell(action)="row">
                      <b-button variant="danger" size="sm" title="Remove" @click="removeItem(row.index)" v-if="showRemoveButton">
                        <CIcon name="cil-minus"/>
                      </b-button>
                    </template>
                    <template #head(action)>
                      <b-button :disabled="table.items >= 5" variant="primary" size="sm" title="Add New Row" @click="addItem"><CIcon name="cil-plus"/></b-button>
                    </template>
                  </b-table>
                  <CRow class="mt-2 float-right">
                    <CCol class="col-12">
                      <b-btn variant="secondary" class="mr-2" @click="$router.back()">Cancel</b-btn>
                      <b-btn variant="primary" type="submit" style="width:4rem" :disabled="isSubmitting" @click="saveApht">
                        <b-spinner small v-if="isSubmitting" />
                        <span v-else>Save</span>
                      </b-btn>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CForm>
  </CContainer>
</template>


<script>
export default {
  name: 'AphtAdd',
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      
      formData: {
        officeCode: {
          value: '',
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "officeCode"
        },
        // certificateNo: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "certificateNo"
        // },
        // certificateStatus: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "certificateStatus"
        // },
        // objectPrice: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "objectPrice"
        // },
        // notaryFee: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "notaryFee"
        // },
        notes: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "notes"
        },
        applNo: {
          value: '',
          isChecking: false,
          isValid: null,
          isRequired: true,
          feedback: 'Appl No is not valid.',
          payloadKey: "applNo"
        },
        contractNo: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "contractNo"
        },
        customerName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "customerName"
        },
        guaranteeValue: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "nilaiPenjaminan"
        },
        financingPrincipal: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "pokokPembiayaan"
        },
      },

      table: {
        isLoaded: true,
        fields: [
          {key: "nomorSertifikatTanah", label: "Nomor Sertifikat", sortable: false},
          {key: "namaSertifikatTanah", label: "Nama Sertifikat", sortable: false},
          {key: "nilaiAppraisal", label: "Nilai Appraisal", sortable: false},
          {key: "statusHak", label: "Status Hak", sortable: false},
          {key: "notaryFee", label: "Biaya Notaris", sortable: false},
          // {key: "action", label: "", sortable: false}
        ],

        items: [],

        validationItems: [],

        template: {
          nomorSertifikatTanah: '',
          namaSertifikatTanah: '',
          nilaiAppraisal: 0,
          notaryFee: 0,
          statusHak: '',
        },

        validationTemplate: {
          nomorSertifikatTanah: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "nomorSertifikatTanah"
          },
          namaSertifikatTanah: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "namaSertifikatTanah"
          },
          nilaiAppraisal: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "nilaiAppraisal"
          },
          notaryFee: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "notaryFee"
          },
          statusHak: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "statusHak"
          },
        },

        currentPage: 1,
      },
    }
  },
  methods: {

    addItem() {
      let item = this.$lodash.cloneDeep(this.table.template)
      let validationItem = this.$lodash.cloneDeep(this.table.validationTemplate)
      this.table.items.push(item)
      this.table.validationItems.push(validationItem)
    },

    removeItem(index) {
      this.table.items.splice(index, 1)
      this.table.validationItems.splice(index, 1)
    },

    async validateApplNo() {
      let getUrl = '/apht/checkContractData'
      let params = {
        applNo: this.formData.applNo.value
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        this.formData.applNo.isChecking = true
        this.table.isLoaded = false
        await this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.applNo.isValid = true
            this.formData.contractNo.value = response.data.data.contractNo
            this.formData.customerName.value = response.data.data.customerName
            this.formData.guaranteeValue.value = response.data.data.nilaiPenjaminan
            this.formData.financingPrincipal.value = response.data.data.pokokPembiayaan
            this.table.items = response.data.data.listApht.map(item => {
              this.table.validationItems.push(this.$lodash.cloneDeep(this.table.validationTemplate))
              return {
                nomorSertifikatTanah: item.nomorSertifikat,
                namaSertifikatTanah: item.namaSertifikat,
                statusHak: item.statusHak,
                nilaiAppraisal: item.nilaiAppraisal,
                notaryFee: 0
              }
            })
          }
          else{
            this.formData.applNo.feedback = "No. Appl tidak valid! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error")
            this.formData.applNo.isValid = false
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.formData.applNo.feedback = "No. Appl tidak valid! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found")
          }
          else{
            this.formData.applNo.feedback = "No. Appl tidak valid! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error")
          }
          this.formData.applNo.isValid = false
        })
        .finally(() => {
          this.formData.applNo.isChecking = false
          this.table.isLoaded = true
        })
      }
      else {
        this.formData.applNo.feedback = "Access Denied!"
        this.formData.applNo.isValid = false
      }
    },
    // clear relevant data when No. APPL changes
    clearFormAppl() {
      this.formData.applNo.isValid = null
      this.formData.contractNo.value = ''
      this.formData.customerName.value = ''
      this.formData.guaranteeValue.value = ''
      this.formData.financingPrincipal.value = ''
    },
    saveApht(event) {
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = { objectApht: [] }
      for(const [key, data] of Object.entries(this.formData)) {
        // skip unused properties
        if(key == "officeCode"){
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
            obj[data.payloadKey] = data.value.officeCode
          }
        }
        // check remaining fields
        else{
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
        }
      }

      let index = 0
      for(const item of this.table.items) {
        let collateralObj = {}
        if (this.$helper.isEmpty(item.nomorSertifikatTanah) && this.table.validationItems[index].nomorSertifikatTanah.isRequired) {
          this.table.validationItems[index].nomorSertifikatTanah.isValid = false
          isFormValid = false
        } else{
          this.table.validationItems[index].nomorSertifikatTanah.isValid = null
          collateralObj[this.table.validationItems[index].nomorSertifikatTanah.payloadKey] = item.nomorSertifikatTanah
        }

        if (this.$helper.isEmpty(item.namaSertifikatTanah) && this.table.validationItems[index].namaSertifikatTanah.isRequired) {
          this.table.validationItems[index].namaSertifikatTanah.isValid = false
          isFormValid = false
        } else{
          this.table.validationItems[index].namaSertifikatTanah.isValid = null
          collateralObj[this.table.validationItems[index].namaSertifikatTanah.payloadKey] = item.namaSertifikatTanah
        }

        if ((this.$helper.isEmpty(item.nilaiAppraisal) || item.nilaiAppraisal == 0) && this.table.validationItems[index].nilaiAppraisal.isRequired) {
          this.table.validationItems[index].nilaiAppraisal.isValid = false
          isFormValid = false
        } else{
          this.table.validationItems[index].nilaiAppraisal.isValid = null
          collateralObj[this.table.validationItems[index].nilaiAppraisal.payloadKey] = item.nilaiAppraisal
        }

        if ((this.$helper.isEmpty(item.notaryFee) || item.notaryFee == 0) && this.table.validationItems[index].notaryFee.isRequired) {
          this.table.validationItems[index].notaryFee.isValid = false
          isFormValid = false
        } else{
          this.table.validationItems[index].notaryFee.isValid = null
          collateralObj[this.table.validationItems[index].notaryFee.payloadKey] = item.notaryFee
        }

        if (this.$helper.isEmpty(item.statusHak) && this.table.validationItems[index].statusHak.isRequired) {
          this.table.validationItems[index].statusHak.isValid = false
          isFormValid = FontFaceSetLoadEvent
        } else{
          this.table.validationItems[index].statusHak.isValid = null
          collateralObj[this.table.validationItems[index].statusHak.payloadKey] = item.statusHak
        }

        obj.objectApht.push(collateralObj)

        index++
      }

      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = ''
        // if editing
        if(!this.$helper.isEmpty(this.$route.params.contractMemoNo)){
          obj["contractMemoNo"] = this.$route.params.contractMemoNo
          postUrl = '/apht/edit'
        }
        // if adding
        else{
          postUrl = '/apht/add'
        }

        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          // console.log(obj)
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){

              this.$store.commit('set', ['toast', true])
              this.$store.commit('set', ['toastMsg', "Edit APHT Berhasil! " + (response.data.reason ? response.data.reason : "")])
              this.$router.push({ name: 'APHT List Created' });
            }
            else{
              this.$helper.toastError(this, (this.$helper.isEmpty(this.mouNo) ? "Edit APHT Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, (this.$helper.isEmpty(this.mouNo) ? "Edit APHT Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, (this.$helper.isEmpty(this.mouNo) ? "Edit APHT Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    async populateOffice(query = "") {
      this.formData.officeCode.isLoaded = false
      this.formData.officeCode.totalPages = 0
      this.formData.officeCode.totalRows = 0
      this.formData.officeCode.currentPage = 1
      this.formData.officeCode.lastQuery = query
      // URL builder
      let getUrl = "/apht/getOfficeByUser"
      let params = {}
      // get content from current page
      params["page"] = (this.formData.officeCode.currentPage - 1)
      params["size"] = this.formData.officeCode.perPage
      if(query !== ""){
        params["filterType"] = "nameFull"
        params["filterValue"] = query
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.officeCode.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.formData.officeCode.options.push(response.data.data.data[i])
            }
            this.formData.officeCode.totalRows = response.data.data.totalElements
            this.formData.officeCode.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.officeCode.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // load more options for modal office dropdown dynamically
    appendOffice() {
      this.formData.officeCode.isLoaded = false
      // URL builder
      let getUrl = "/apht/getOfficeByUser"
      let params = {}
      // get content from next page
      params["page"] = this.formData.officeCode.currentPage
      params["size"] = this.formData.officeCode.perPage
      if(this.formData.officeCode.lastQuery !== ""){
        params["filterType"] = "nameFull"
        params["filterValue"] = this.formData.officeCode.lastQuery
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.formData.officeCode.options.push(response.data.data.data[i])
            }
            this.formData.officeCode.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.officeCode.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    initialSetup(){
      let getUrl = "/apht/getDetail"
      let params = {
        contractMemoNo: this.$route.params.contractMemoNo
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        // use index to properly update table row after manipulation
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            // this.initData()
            this.formData.applNo.value = response.data.data.applNo
            // this.formData.certificateNo.value = response.data.data.certificateNo
            // this.formData.certificateStatus.value = response.data.data.certificateStatus
            this.formData.contractNo.value = response.data.data.contractNo
            this.formData.customerName.value = response.data.data.customerName
            this.formData.guaranteeValue.value = response.data.data.nilaiPenjaminan
            // this.formData.notaryFee.value = response.data.data.notaryFee
            this.formData.notes.value = response.data.data.notes
            // this.formData.objectPrice.value = response.data.data.objectPrice
            this.formData.financingPrincipal.value = response.data.data.pokokPembiayaan

            let found = false
            for(let i = 0; i < this.formData.officeCode.options.length; i++){
              if(this.formData.officeCode.options[i].officeCode == response.data.data["officeCode"]){
                this.formData.officeCode.value = this.formData.officeCode.options[i]
                found = true
                break
              }
            }
            if (!found) {
              this.formData.officeCode.value = { officeCode: response.data.data["officeCode"], nameShort: response.data.data["officeNameShort"], nameFull: response.data.data["officeNameFull"] }
            }

            // List Collateral
            for(const item of response.data.data.listCollateral) {
              this.table.items.push({
                id: item.id,
                nomorSertifikatTanah: item.nomorSertifikatTanah,
                namaSertifikatTanah: item.namaSertifikatTanah,
                nilaiAppraisal: item.nilaiAppraisal,
                notaryFee: item.notaryFee,
                statusHak: item.statusHak,
              })
              let validationItem = this.$lodash.cloneDeep(this.table.validationTemplate)
              this.table.validationItems.push(validationItem)
            }
          }
          else{
            this.$helper.toastError(this, "Get Detail APHT Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Get Detail APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Get Detail APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
  },
  computed:{
    showRemoveButton(){
      if (this.table.items.length > 1) {
        return true
      } else{
        return false
      }
    }
  },
  async created(){
    this.populateOffice().then(() => {
      this.initialSetup()
    })
  }
}
</script>

<style>

</style>
